var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-title text--primary"},[_c('i',{staticClass:"fas legend-title__icon",class:("fa-" + _vm.iconName)}),_c('span',{staticClass:"text-legend legend-title__text"},[_vm._v(_vm._s(_vm.title)+":")])])}
var staticRenderFns = []

export { render, staticRenderFns }